import Call from '../Call';

const MasterCron = {
    getPage(page) {
        return Call(`masterCron/${page}`);
    }
}

export default MasterCron;


// WEBPACK FOOTER //
// ./src/services/API/components/MasterCron.js